// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quotes-swiper[data-v-75f7a62f]{position:relative;margin-bottom:var(--mobile-block-margin)}@media(min-width:640px){.quotes-swiper[data-v-75f7a62f]{margin-bottom:var(--block-margin)}}.quotes-swiper .swiper-slide[data-v-75f7a62f]{padding:0}.quotes-swiper .swiper-pagination[data-v-75f7a62f]{bottom:0}.quotes-swiper[data-v-75f7a62f]:not(.loading){margin-left:-15px;margin-right:-15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
